export const en = {
  common: {
    yes: 'Yes',
    no: 'No',
    saved: 'Saved',
    get_started: 'Get started',
    get_started_today: 'Get started today',
    filter: 'Filter',
    all: 'All',
    apply: 'Apply',
    unsavedChanges: 'You have unsaved changes',
    discard: 'Discard',
    saveChanges: 'Save changes',
    confirm: 'Confirm',
    cancel: 'Cancel',
    back: 'Back',
    welcome_back: 'Welcome back',
  },
}
